"use client"

// Toast ENGINE = @owlcat/ui sonner. The radix Toaster implementation is removed;
// this wraps the shared sonner <Toaster /> so existing mount sites are unchanged.
//
// WHY the explicit style map: @owlcat/ui maps sonner's CSS variables onto
// bare tokens (`--normal-bg: var(--popover)`), which works for packages/ui's
// oklch() tokens but NOT for this storefront, whose tokens are raw HSL
// triplets (`--popover: 30 15% 12%`). An unwrapped triplet is an invalid
// <color>, so sonner's background/color/border collapsed to `initial` —
// transparent box, black text — unreadable on the dark theme. We wrap every
// token in hsl() here and give the error/success variants solid, high-
// contrast colours (`richColors` makes sonner apply them).
import { Toaster as SonnerToaster } from "@owlcat/ui"
import type * as React from "react"

const toasterStyle = {
  "--normal-bg": "hsl(var(--popover))",
  "--normal-text": "hsl(var(--popover-foreground))",
  "--normal-border": "hsl(var(--border))",
  "--success-bg": "hsl(var(--success))",
  "--success-text": "hsl(var(--success-foreground))",
  "--success-border": "hsl(var(--success))",
  "--error-bg": "hsl(var(--destructive))",
  "--error-text": "hsl(var(--destructive-foreground))",
  "--error-border": "hsl(var(--destructive))",
  "--border-radius": "var(--radius)",
} as React.CSSProperties

export function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
  return (
    <SonnerToaster
      richColors
      closeButton
      toastOptions={{
        classNames: {
          // Keep description readable on the solid error/success surfaces
          // (sonner's default dims it to 60% of the text colour).
          description: "!text-inherit !opacity-90 whitespace-pre-line",
        },
      }}
      {...props}
      style={{ ...toasterStyle, ...(props.style ?? {}) }}
    />
  )
}
